module.exports = __webpack_public_path__ + "static/media/28.ee22cfb0.jpg";